import { ResponsePageable } from './../../../model/cliente/pageable/responsePageable.model';
import { TipoCaixaService } from './../../../service/caixa/tipo-caixa.service';
import { TipoConteudoService } from './../../../service/caixa/tipo-conteudo.service';
import { TipoConteudoModel } from './../../../model/caixa/tipoconteudo.model';
import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import { MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';

@Component({
  selector: 'app-tipo-conteudo',
  templateUrl: './tipo-conteudo.component.html',
  styleUrls: ['./tipo-conteudo.component.scss']
})
export class TipoConteudoComponent implements OnInit {
  tipoConteudo = {} as TipoConteudoModel;
  tipoConteudos: TipoConteudoModel[];
  page: ResponsePageable;
  submit = false;
  edited = false;
  editado = false;
  errorAlert = false;
  successDelete = false;
  messageError = false;
  mensagemDeErro = '';
  pageAtual = 0;

  user: any;
  userAdmin = false;
  userUser = false;
  userEditor = false;
  userCreator = false;

  public arrayString: string;
  public creatorTpConteudo = false;
  public editorTpConteudo = false;
  public listaTpConteudo = false;
  public deletaTpConteudo = false;
  public superUser = false;
  horizontalPosition: MatSnackBarHorizontalPosition = 'right';
  verticalPosition: MatSnackBarVerticalPosition = 'top';
  @ViewChild('cardAdd') targetEl: ElementRef;

  constructor(private tipoConteudoService: TipoConteudoService,
    private _snackBar: MatSnackBar) { }

  ngOnInit() {
    this.listarTipoConteudos(0, 10);
    this.getAuthority();
  }

  onSubmit() {
    this.submit = true;
  }

  changePage(event) {
    this.listarTipoConteudos(event.page, event.size);
    this.pageAtual = event.page;
   }

  listarTipoConteudos(page: number, size: number) {
    this.tipoConteudoService.getTiposConteudos(page, size).subscribe(data => {
      this.tipoConteudos = data.content;
    }, err => {
      console.error(err);
    });
  }

  postSubmit() {
    this.submit = false;
    this.tipoConteudo.id = undefined;
  }

  scroll() {
    this.targetEl.nativeElement.scrollIntoView();
  }

  // Adicionar ou Editar tipo de Caixa
  manterTipoConteudo() {
    this.tipoConteudoService.addTipoConteudo(this.tipoConteudo).subscribe(
      () => {
        // Edição
        if (this.tipoConteudo.id !== undefined) {
          this.tipoConteudo = new TipoConteudoModel();
          this.listarTipoConteudos(this.pageAtual, 10);
          this.postSubmit();
          this.openSnackBarSuccess('Tipo de Conteúdo atualizado com sucesso !');
        } else {
          this.tipoConteudo = new TipoConteudoModel();
          this.listarTipoConteudos(0, 10);
          this.postSubmit();
          this.openSnackBarSuccess('Tipo de Conteúdo salvo com sucesso !');
        }
      },
      (error) => {
        console.error(error);
        this.mensagemDeErro = error.error.message;
        this.openSnackBarError(`Erro !`);
      }
    );
  }

  // Get dados do tipo de Caixa para editar
  getDados(tipoConteudo: TipoConteudoModel) {
    this.tipoConteudo = { ...tipoConteudo};
  }

  getAuthority() {
    this.getItemAuthority('authority');
    if (this.arrayString.includes('ADD_EMPRESA')) {
      this.creatorTpConteudo = true;
    }
    if (this.arrayString.includes('EDIT_EMPRESA')) {
      this.editorTpConteudo = true;
    }
    if (this.arrayString.includes('LIST_EMPRESA')) {
      this.listaTpConteudo = true;
    }
    if (this.arrayString.includes('DELETE_EMPRESA')) {
      this.deletaTpConteudo = true;
    }
    if (this.arrayString.includes('SUPER_USER')) {
      this.superUser = true;
    }
  }

  getItemAuthority(key) {
    const store = sessionStorage.getItem(key);
    if (store) {
      try {
        const bytes = CryptoJS.AES.decrypt(
          store,
          sessionStorage.getItem('ticket-ECM')
        );
        this.arrayString = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
        return this.arrayString;
      } catch (e) {
        sessionStorage.clear();
      }
    }

    return null;
  }

  // Alert Excluir Tipo De Caixa
  confirmeExcluir(id: number) {
    const confirme = confirm('Deseja excluir este Tipo de Caixa ?');
    if (confirme) {
      this.apagarTipoConteudo(id);
    } else {
      console.log('Cancelou exclusão');
    }
  }

  // Excluir Tipo De Caixa
  apagarTipoConteudo(id: number) {
    this.tipoConteudoService.deleteTipoConteudo(id).subscribe(() => {
      this.openSnackBarSuccess('Tipo de Conteúdo excluído com sucesso !');
      this.listarTipoConteudos(0, 10);
    }, error => {
      console.error(error);
      this.openSnackBarError('Erro ao excluir! Este Tipo de Conteúdo está sendo usado por um conteúdo.');
    });
  }

  // SnackBares
  openSnackBarSuccess(message: string) {
    this._snackBar.open(message, '', {
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      duration: 4000,
      panelClass: ['success-snackbar']
    });
  }

  openSnackBarError(message: string) {
    this._snackBar.open(message,'', {
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      duration: 3000,
      panelClass: ['error-snackbar']
    });
  }

}



// WEBPACK FOOTER //
// /app/src/app/components/caixa/tipo-conteudo/tipo-conteudo.component.ts